import { AvailableChildrenType, SugarElementInfo } from "../../SugarElementInfo";

export const sub: SugarElementInfo = { name: "sub", availableChildren: { type: AvailableChildrenType.Any } };
